/**
 * 处理图标数据 获取x,y轴的数据
 * @param {Object} time 查询日期
 * @param {Object} data 图表数据
 */
export function useXYData(time, data, option) {
    if (!option) {
        option = { x: 'time', y: 'amount' }
    }
    let edata = {
        xData: [],
        yData: []
    }
    if (time.mode == '今日') {
        edata = handlerDayData(data, option)
    } else if (time.mode == '本周') {
        edata = handlerWeekData(data, time.list, option)
    } else if (time.mode == '本月') {
        edata = handlerMonthData(data, time.list, option)
    } else if (time.mode == '本年') {
        edata = handlerYearData(data, time.list, option)
    } else {
        edata = handlerCustomData(data, time.list, option)
    }
    return edata
}


//处理今日柱状图数据
function handlerDayData(list, option) {
    let x = []
    let y = []
    for (let i = 6; i < 23; i++) {
        x.push(zero(i) + ':00')
        y.push(0)
    }

    list.forEach(item => {
        let i = x.indexOf(item.time)
        if (i != -1) {
            y[i] = item[option.y]
        }
    })
    return {
        xData: x,
        yData: y
    }
}
//处理本周柱状图数据
function handlerWeekData(list, date, option) {
    let name = []
    let value = []
    let s = newDate(date[0]).getTime()
    let day = 1000 * 24 * 60 * 60
    for (let i = 0; i < 7; i++) {
        name.push(newDate(day * i + s).Format('MM-dd'))
        value.push(0)
    }
    list.forEach(item => {
        let i = name.indexOf(item.time)
        if (i != -1) {
            value[i] = item[option.y]
        }
    })
    return {
        xData: name,
        yData: value
    }
}
//处理本月柱状图数据
function handlerMonthData(list, date, option) {
    let name = []
    let value = []
    let s = newDate(date[0]).getTime()
    let n = newDate(date[1]).getDate()
    let day = 1000 * 24 * 60 * 60
    for (let i = 0; i < n; i++) {
        name.push(newDate(day * i + s).Format('MM-dd'))
        value.push(0)
    }
    list.forEach(item => {
        let i = name.indexOf(item.time)
        if (i != -1) {
            value[i] = item[option.y]
        }
    })
    return {
        xData: name,
        yData: value
    }
}

function handlerCustomData(list, date, option) {
    let name = []
    let value = []
    list.forEach(item => {
        name.push(item.time)
        value.push(item[option.y])
    })

    return {
        xData: name,
        yData: value
    }
}

function handlerYearData(list, date, option) {
    let n = newDate().getMonth() + 1
    let name = []
    let value = []
    for (let i = 1; i <= n; i++) {
        name.push(zero(i))
        value.push(0)
    }
    console.log(name);
    list.forEach(item => {
        let i = name.indexOf(item.time)
        if (i != -1) {
            value[i] = item[option.y]
        }
    })
    name = name.map(t => {
        return t + '月'
    })
    return {
        xData: name,
        yData: value
    }
}

function zero(v) {
    return v >= 10 ? v : '0' + v
}


function newDate(time) {
    return new Date(time)
}


export function commXYData(list, option) {
    if (!option) {
        option = { x: 'name', y: 'count' }
    }
    let name = []
    let value = []
    list.forEach(item => {
        name.push(item[option.x])
        value.push(item[option.y])
    })

    return {
        xData: name,
        yData: value
    }
}